import React, {useEffect} from "react";
import { Trans, useTranslation } from "react-i18next";
import footerImg from "../images/landing/footer-img.jpg";

import logo from "../images/logoTY.png";


const ThankYou = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const script = document.createElement('script')
    script.text = "fbq('track', 'Purchase', {currency: 'EUR', value: 0.00});";
    document.head.appendChild(script);
  }, [])

  return (
    <>
      <div className="container">
        <div className="thankyou-wrapper text-center">
          <a href="/" title="" className="text-center d-block">
            <img src={logo} alt="" />
          </a>
          <span className="text-themee">{t("thankyouroom.grazie")}</span>
          <p>
            <Trans t={t}>{t("thankyouroom.p")}</Trans>
          </p>
        </div>
      </div>
      <footer className="thnk-footer">
        <div className="container">
          <div className="foter-txt text-center">
            <p>{t("landing.footer.1")}</p>
            <img src={footerImg} alt="" className="img-fluid" />
            <p>{t("landing.footer.2")}</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ThankYou;
